import { TwinUser } from '@aize/authentication';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { ApplicationAuthServiceInterface } from '@models/authentication';
import jwtDecode from 'jwt-decode';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { filter, from, map, Observable, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KeycloakAuthService implements ApplicationAuthServiceInterface {
  twinUser$: Observable<TwinUser> = of(null);
  isLoggedIn = false;

  private readonly keycloak = inject(KeycloakService);

  init(): Observable<string> {
    return of('KeycloakAuthService: initialize...');
  }

  getUserProfile(): Observable<TwinUser> {
    return from(of(this.keycloak.isLoggedIn())).pipe(
      tap(isLoggedIn => (this.isLoggedIn = isLoggedIn)),
      filter(isLoggedIn => isLoggedIn),
      switchMap(() => from(this.keycloak.loadUserProfile())),
      map(keycloakProfile => {
        if (!environment.production) {
          this.keycloak.getToken().then(value => {
            if (value !== 'test-token-string') {
              console.info(this.decodeToken(value));
            }
          });
        }
        return this.buildProfile(keycloakProfile);
      })
    );
  }

  buildProfile(keycloakProfile: KeycloakProfile): TwinUser {
    const displayName = keycloakProfile.firstName + ' ' + keycloakProfile.lastName;
    return {
      applicationDisplayName: displayName,
      email: keycloakProfile.email,
      displayName,
      avatar: '',
      defaultTenant: 'T101014843',
      currentTenant: 'T101014843',
      tenants: [
        {
          id: 'T101014843',
          name: 'Keycloak Test'
        },
        {
          id: 'T101014844',
          name: 'Aize Test tenant'
        }
      ]
    };
  }

  decodeToken(token: string): string {
    return jwtDecode(token);
  }

  logout() {
    this.keycloak.logout();
  }

  login(): Observable<string> {
    return from(this.keycloak.login().then(value => 'KeycloakAuthService: login...'));
  }
}
